module.exports = {
  log: false,
  logger: () => {},
  progress: () => {},
};
